import * as React from 'react'
import  {useState, useEffect} from 'react'
import classnames from 'classnames'
import style from './style.module.css'
// import warn from './image/error.png'
// import normal from './image/normal.png'
// import success from './image/success.png'
// import prompt from './image/prompt.png'

export type IEvent = () => any
export type TFontSize = 'small' | 'middle' | 'big'
export type TipsType = 'success' | 'warn' | 'prompt' | 'default'

export interface ITopTipsConfig {
  type: TipsType | string
  text?: string | React.ReactElement | number
  footer?: string | React.ReactChild | number
  imgShow?: boolean
  timeout?: number
  onClick?: IEvent
  autoClose?: Boolean
  fontSize?: TFontSize
  animation?: boolean
}

export const defaultConfig = {
  type: 'success',
  text: 'help',
  imgShow: true,
  autoClose: true,
  fontSize: 'middle' as TFontSize,
  animation: true
}


let bridge: {
  showTopTips?: (config: ITopTipsConfig) => void,
  hideTopTips?: () => void
} = {}

// 暴露给用户调用的方法
export function showTopTips(config: ITopTipsConfig):void {
  if (bridge.showTopTips) {
    bridge.showTopTips(config)
  }
}

export function hideTopTips() {
  if(bridge.hideTopTips) {
    bridge.hideTopTips()
  }
}


export function TopTips() {
  const [show,setShow] = useState<boolean>(false)
  const [ config, setConfig ] = useState<ITopTipsConfig>(defaultConfig)

  useEffect(() => {
    let timer = 0
    bridge.showTopTips = (config: ITopTipsConfig ) => {
      clearTimeout(timer)
      setShow(true)
      setConfig(config)

      if(config.autoClose) {
        timer = Number(setTimeout(() =>{
          setShow(false)
        },config.timeout || 1500))
      }
    }

    bridge.hideTopTips = () => {
      setShow(false)
    }

    return () => {
      clearTimeout(timer)
    }
  },[])

  const defaultFunction = ()  => {
    if(!config.autoClose) {
      setShow(false)
    }
  }

  const renderimg = () => {
    const imgMap = {
      'warn': 'https://img.lycheer.net/material/59358349/5cc6ea9f3ef8b0592b0d497c.png',
      'success': 'https://img.lycheer.net/material/59358349/5cc6ea9f134f8758f0d67eca.png',
      'prompt': 'https://img.lycheer.net/material/59358349/5cc6ea9fff485f0e9adb58b9.png'
    }

    const defaultImg = 'https://img.lycheer.net/material/59358349/5cc6ea9f5b87a00e64281c06.png'

    const img = imgMap[config.type] || defaultImg
    return  <img src={img} className={style['top-tips-img']}/>
  }

  return(
    <div className={style['top-tips-box']} style={{zIndex: 100}} id='weike-ui-top-tips'>
      {
        show && <div className={ classnames(style['top-tips'],style[`top-tips-${config.fontSize}`])}>
          <div className={classnames(style['top-tips--inline-box'],style[`top-tips-${config.type}`],
          config.animation ? style['top-tips-animation'] : '')}>
          <div className={style['top-tips--left-box']}>
           {config.imgShow && renderimg()}
           <span className={style['top-tips--left-text']}>
            {config.text}
           </span>
           </div>
           <div className={style['toptips-footer']}  onClick={ config.onClick || defaultFunction  }>
           {config.footer}
           </div>
          </div>
        </div>
      }
    </div>
  )
}



// WEBPACK FOOTER //
// ../src/popup-layer/toptip/index.tsx